import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import {
  deleteEmailTemplate,
  deleteEmailTemplateSuccess,
  emailTemplateData,
  emailTemplateList,
} from "../../../../../store/CRMitEmailInbox/action";
import EmailInbound from "../../../../../store/CRMitEmailInbox/reducer";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { handleRichTextOutput } from "../../../../../Components/Common/HandleRichTextOutput";
import { isEmpty } from "lodash";
import CreateEditEmailTemplate from "../../../../../Components/popUpComponents/CreateEditEmailTemplate";
import DeleteModal from "../../../../../Components/Common/DeleteModal";
import { toast } from "react-toastify";
import { FetchAPI } from "../../../../../helpers/APIdata/fetchAPI";
import LocalDataSearch from "../../../../../Components/SearchAndFilter";
import LoadingSpinner from "../../../../../Components/Common/Spinner";
import TableContainer from "../../../../../Components/Common/TableContainer";
import NoDataContent from "../../../../../Components/Common/NoDataContent";
import { getProductDetail } from "../../../../../store/products/action";

const TabEmailTemplate = () => {
  const dispatch = useDispatch();

  // Local States
  const [searchResultList, setSearchResultList] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "FullName",
    "Id",
    "Subject",
    "Title",
    "ContactEmailAddress",
    "ReceiptReference",
    "AddressPostCode",
    "ContactTelephoneNumber",
  ]);
  const allowedFiltersInit = [
    {
      useThisFilter: true,
      filterTitle: "Created Date Range",
      filterType: "DateRange",
      filterProperty: "CreatedDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
  ];

  const [allowedFilters, setAllowedFilters] = useState(allowedFiltersInit);

  const [showFilter, setShowFilter] = useState(false);
  const toggleShowFilter = () => setShowFilter(!showFilter);
  const [searchInActionShowLoading, setSearchInActionShowLoading] =
    useState(false);

  const {
    emailTemplateListAPI,
    emailTemplateDelete,
    emailTemplateListLoading,
  } = useSelector((state) => ({
    emailTemplateListAPI:
      state.EmailInbound.emailTemplateList?.emailtemplate_list,
    emailTemplateDelete: state.EmailInbound.emailTemplateDelete,
    emailTemplateListLoading: state.EmailInbound.emailTemplateListLoading,
  }));

  useEffect(() => {
    dispatch(emailTemplateList());
  }, []);

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (customer) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                #{customer.row.original?.Id}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Title",
        accessor: "Title",
        filterable: true,
      },
      {
        Header: "Subject",
        accessor: "Subject",
        filterable: true,
      },
      {
        Header: "From Email",
        accessor: "FromEmail",
        filterable: true,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-soft-info btn-icon fs-14"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-ellipsis"></i>
              </DropdownToggle>
              <DropdownMenu>
                <li>
                  <DropdownItem>
                    <div
                      className="edit-item-btn"
                      onClick={() => {
                        handleEdit(cellProps.row.original?.Id);
                      }}
                    >
                      <div className={"d-flex align-items-center"}>
                        <i className="ri-pencil-fill align-center text-muted me-1"></i>
                        <span>Edit / View</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem>
                    <div
                      className="edit-item-btn"
                      onClick={() => {
                        handleDuplicate(cellProps.row.original?.Id);
                      }}
                    >
                      <div className={"d-flex align-items-center"}>
                        <i className="ri-file-copy-line align-center text-muted me-1"></i>
                        <span>Duplicate</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem>
                    <div
                      className="remove-item-btn"
                      onClick={() => {
                        handleDelete(cellProps?.row.original?.Id);
                      }}
                    >
                      <div className={"d-flex align-items-center"}>
                        <i className="ri-delete-bin-fill align-center text-muted me-1"></i>{" "}
                        <span>Delete</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    [emailTemplateListAPI]
  );

  const handleJobSearch = (e) => {
    e.preventDefault();
    setSearchQuery(e.target.value);
  };

  const [activeSearchTab, setActiveSearchTab] = useState("all");

  const [modalTemplate, setModalTemplate] = useState(false);
  // Change #100363 - the template being duplicated, while the modal is open for it
  const [duplicateFrom, setDuplicateFrom] = useState(null);
  const toggleTemplate = () => {
    if (modalTemplate) setDuplicateFrom(null);
    setModalTemplate(!modalTemplate);
  };
  const [isEdit, setIsEdit] = useState(false);
  const handleEdit = (id) => {
    setIsEdit(true);
    setDuplicateFrom(null);
    toggleTemplate();
    dispatch(emailTemplateData({ id }));
  };
  const handleCreate = () => {
    setIsEdit(false);
    setDuplicateFrom(null);
    toggleTemplate();
  };
  // Change #100363 - open the Create modal already filled in from a template
  // ("Copy of ..."), so it can be reworded (e.g. a per-coupon email, #100360)
  // before anything is saved. Only the content is copied: never the
  // default-for-invoices flags, so a copy can not become a second default.
  const handleDuplicate = async (id) => {
    const source = await FetchAPI(`/emailtemplate/data/${id}`, "GET");
    const t = source?.emailtemplate_data;
    if (source?.status !== 200 || !t) {
      toast.error(source?.message || "Could not read that template");
      return;
    }
    setIsEdit(false);
    setDuplicateFrom(t);
    setModalTemplate(true);
  };
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDelete = () => setDeleteModal(!deleteModal);
  const handleDelete = (id) => {
    setDeleteItem(id);
    toggleDelete();
  };
  const deleteTemplate = () => {
    dispatch(deleteEmailTemplate([deleteItem]));
  };

  useEffect(() => {
    if (isEmpty(emailTemplateDelete)) return;
    if (emailTemplateDelete?.status === 200) {
      toggleDelete();
      dispatch(emailTemplateList());
      toast.success(emailTemplateDelete?.message);
    } else {
      toast.error(emailTemplateDelete?.message);
    }
    dispatch(deleteEmailTemplateSuccess([]));
  }, [emailTemplateDelete]);
  return (
    <React.Fragment>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onCloseClick={toggleDelete}
          onDeleteClick={deleteTemplate}
          customText={"Are you sure you want to delete this Template?"}
          customButtonText={"Yes, Delete It!"}
        />
      )}
      {modalTemplate && (
        <CreateEditEmailTemplate
          modal={modalTemplate}
          toggle={toggleTemplate}
          isEdit={isEdit}
          duplicateFrom={duplicateFrom}
        />
      )}
      <LocalDataSearch
        Page={"StaffSingleLeaveRequestPage"}
        ReceivedDataAPI={emailTemplateListAPI} // Mandatory* | Array of Objects
        setSearchInActionShowLoading={setSearchInActionShowLoading} //Mandatory* can be on and off for search loading if data heavy page I recommend to use it
        activeSearchTab={activeSearchTab} //Mandatory* | String
        // recurringJobListDataAPI={recurringJobListData} // Job Page Spesific
        allowedSearchFilters={allowedSearchFilters}
        searchQuery={searchQuery}
        setSearchFilteredResults={setSearchResultList}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        toggleShowFilter={toggleShowFilter}
        allowedFiltersInit={allowedFiltersInit}
        allowedFilters={allowedFilters}
        setAllowedFilters={setAllowedFilters}
      />
      <div>
        <div>
          <div>
            <Row>
              <Col lg={12}>
                <Card id="customersList">
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <Col sm={3}>
                        <div className="search-box">
                          <Input
                            // create search with jobs List Data
                            type="search"
                            className="form-control search"
                            placeholder="Search for..."
                            onChange={handleJobSearch}
                            value={searchQuery}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </Col>
                      <Col sm={9} className={"d-flex justify-content-end"}>
                        <div className={"d-flex justify-content-end me-2"}>
                          <button
                            onClick={handleCreate}
                            className={"btn btn-success"}
                          >
                            + New Template
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <div>
                      {emailTemplateListLoading ? (
                        <LoadingSpinner />
                      ) : (
                        <>
                          {!isEmpty(searchResultList) ? (
                            <TableContainer
                              columns={columns}
                              data={searchResultList}
                              isGlobalFilter={false}
                              isAddUserList={false}
                              customPageSize={10}
                              className="custom-header-css"
                              divClass="table-responsive table-card mb-0"
                              tableClass="align-middle table-wrap"
                              theadClass="text-muted"
                              // handleLeadClick={handleLeadClicks}
                              isLeadsFilter={false}
                            />
                          ) : (
                            <>
                              {emailTemplateListAPI?.length === 0 ? (
                                <div id={"zbtn_customer_create_01"}>
                                  <NoDataContent
                                    titleText={`No Data Found`}
                                    paragraphText={`No data available`}
                                    useButton={false}
                                    // buttonOnClick={setModalCreateCustomer}
                                    // buttonText={"New Customer"}
                                  />
                                </div>
                              ) : (
                                <div id={"zbtn_customer_create_01"}>
                                  <NoDataContent
                                    titleText={` No Results for: ${searchQuery}`}
                                    paragraphText={`Try Different Search Terms or Remove Filters.`}
                                    useButton={false}
                                    // buttonText={"New Leave Request"}
                                    // buttonOnClick={setModalCreateCustomer}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TabEmailTemplate;

// const TabEmailTemplate = () => {
//   const dispatch = useDispatch();
//
//   useEffect(() => {
//     dispatch(emailTemplateList());
//   }, []);
//
//   const { emailTemplateListAPI, emailTemplateDelete } = useSelector(
//     (state) => ({
//       emailTemplateListAPI:
//         state.EmailInbound.emailTemplateList?.emailtemplate_list,
//       emailTemplateDelete: state.EmailInbound.emailTemplateDelete,
//     })
//   );
//
//   console.log("emailTemplateListAPI", emailTemplateListAPI);
//   const [searchResults, setSearchResults] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [allowedFilters, setAllowedFilters] = useState([
//     "FromEmail",
//     "FromName",
//     "Subject",
//     "BodyHtml",
//     "Title",
//     "Description",
//   ]);
//
//   useEffect(() => {
//     if (isEmpty(emailTemplateListAPI)) {
//       setSearchResults([]);
//     } else {
//       const results = emailTemplateListAPI?.filter((template) => {
//         return allowedFilters.some((filter) => {
//           return template[filter]
//             ?.toLowerCase()
//             ?.includes(searchQuery.toLowerCase());
//         });
//       });
//       setSearchResults(results);
//     }
//   }, [emailTemplateListAPI, searchQuery]);
//
//   const [modalTemplate, setModalTemplate] = useState(false);
//   const toggleTemplate = () => setModalTemplate(!modalTemplate);
//   const [isEdit, setIsEdit] = useState(false);
//   const handleEdit = (id) => {
//     setIsEdit(true);
//     toggleTemplate();
//     dispatch(emailTemplateData({ id }));
//   };
//   const handleCreate = () => {
//     setIsEdit(false);
//     toggleTemplate();
//   };
//   const [deleteItem, setDeleteItem] = useState(null);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const toggleDelete = () => setDeleteModal(!deleteModal);
//   const handleDelete = (id) => {
//     setDeleteItem(id);
//     toggleDelete();
//   };
//   const deleteTemplate = () => {
//     dispatch(deleteEmailTemplate([deleteItem]));
//   };
//
//   useEffect(() => {
//     if (isEmpty(emailTemplateDelete)) return;
//     if (emailTemplateDelete?.status === 200) {
//       toggleDelete();
//       dispatch(emailTemplateList());
//       toast.success(emailTemplateDelete?.message);
//     } else {
//       toast.error(emailTemplateDelete?.message);
//     }
//     dispatch(deleteEmailTemplateSuccess([]));
//   }, [emailTemplateDelete]);
//   return (
//     <div>
//       {deleteModal && (
//         <DeleteModal
//           show={deleteModal}
//           onCloseClick={toggleDelete}
//           onDeleteClick={deleteTemplate}
//           customText={"Are you sure you want to delete this Template?"}
//           customButtonText={"Yes, Delete It!"}
//         />
//       )}
//       {modalTemplate && (
//         <CreateEditEmailTemplate
//           modal={modalTemplate}
//           toggle={toggleTemplate}
//           isEdit={isEdit}
//         />
//       )}
//       <div>
//         <Row>
//           <Col lg={9}>
//             <input
//               type="text"
//               className="form-control mb-2"
//               placeholder="Search Templates"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </Col>
//           <Col lg={3}>
//             <div className={"d-flex justify-content-end me-2"}>
//               <button onClick={handleCreate} className={"btn btn-success"}>
//                 + New Template
//               </button>
//             </div>
//           </Col>
//         </Row>
//       </div>
//       <Row
//         style={{
//           maxHeight: "70vh",
//           overflow: "scroll",
//           overflowX: "hidden",
//           marginTop: "15px",
//         }}
//       >
//         {searchResults?.map((template) => (
//           <Col key={template?.Id} lg={template?.expandBody ? 12 : 4}>
//             <Card className={"p-2"}>
//               <div>Title: {template?.Title}</div>
//               <div>Description: {template?.Description}</div>
//               <div>From: {template?.FromEmail}</div>
//               <div>Name: {template?.FromName}</div>
//               <div>Subject: {template?.Subject}</div>
//
//               {template?.expandBody && (
//                 <div className={"mt-1"}>
//                   {
//                     // need to parse html template?.BodyHtml
//                     handleRichTextOutput(template?.BodyHtml)
//                   }
//                 </div>
//               )}
//               <div className={"d-flex justify-content-between mt-2"}>
//                 <div>
//                   <button
//                     className={
//                       template.expandBody
//                         ? "btn btn-sm btn-info"
//                         : "btn btn-sm btn-soft-info"
//                     }
//                     onClick={() => {
//                       template.expandBody = !template.expandBody;
//                       setSearchResults([...searchResults]);
//                     }}
//                   >
//                     {template?.expandBody ? "Hide  Body" : "Show  Body"}
//                   </button>
//                 </div>
//                 <div>
//                   <button
//                     className={"btn btn-sm btn-danger me-2"}
//                     onClick={() => {
//                       handleDelete(template?.Id);
//                     }}
//                   >
//                     Delete
//                   </button>
//                   <button
//                     className={"btn btn-sm btn-warning"}
//                     onClick={() => {
//                       handleEdit(template?.Id);
//                     }}
//                   >
//                     Edit
//                   </button>
//                 </div>
//               </div>
//             </Card>
//           </Col>
//         ))}
//       </Row>
//     </div>
//   );
// };
//
// export default TabEmailTemplate;
